// LLM generated - Model Claude 4 Sonnet
export function OFPlogoLogin({
  height = 16,
  color = '#495057',
}: {
  height?: number;
  color?: string;
}) {
  // Calculate width based on original aspect ratio (134/16 ≈ 8.375)
  const width = height * (134 / 16);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 134 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Vector">
        <path d="M130.841 12.9289V1.18272H133.19V12.9289H130.841Z" fill={color} />
        <path
          d="M125.09 13.1233C122.433 13.1233 120.554 11.2601 120.554 8.60305C120.554 5.94599 122.433 4.0828 125.09 4.0828C127.747 4.0828 129.627 5.94599 129.627 8.60305C129.627 11.2601 127.747 13.1233 125.09 13.1233ZM125.074 10.9361C126.37 10.9361 127.278 9.98019 127.278 8.60305C127.278 7.22591 126.37 6.25382 125.09 6.25382C123.81 6.25382 122.903 7.22591 122.903 8.60305C122.903 9.98019 123.794 10.9361 125.074 10.9361Z"
          fill={color}
        />
        <path
          d="M114.965 13.1233C112.308 13.1233 110.428 11.2601 110.428 8.60305C110.428 5.94599 112.308 4.0828 114.965 4.0828C117.622 4.0828 119.501 5.94599 119.501 8.60305C119.501 11.2601 117.622 13.1233 114.965 13.1233ZM114.949 10.9361C116.245 10.9361 117.152 9.98019 117.152 8.60305C117.152 7.22591 116.245 6.25382 114.965 6.25382C113.685 6.25382 112.778 7.22591 112.778 8.60305C112.778 9.98019 113.669 10.9361 114.949 10.9361Z"
          fill={color}
        />
        <path
          d="M100.368 9.99639C100.368 9.34832 100.385 8.92708 100.417 8.44103C100.563 5.76777 102.264 4.0828 104.824 4.0828C107.691 4.0828 109.376 6.0594 109.376 8.73266C109.376 11.1953 107.562 13.0585 105.196 13.0585C104.095 13.0585 103.22 12.6697 102.701 11.9892V15.5211H100.368V9.99639ZM104.872 10.8875C106.168 10.8875 107.043 9.96399 107.043 8.58685C107.043 7.24212 106.168 6.27002 104.872 6.27002C103.592 6.27002 102.718 7.24212 102.718 8.58685C102.718 9.99639 103.56 10.8875 104.872 10.8875Z"
          fill={color}
        />
        <path
          d="M93.5832 12.9289V1.18272H95.9325V12.9289H93.5832ZM96.7426 12.9289V1.18272H99.0918V12.9289H96.7426Z"
          fill={color}
        />
        <path
          d="M87.3825 13.1233C84.8388 13.1233 83.1376 11.3735 83.1376 8.74886C83.1376 5.92979 84.9522 4.0828 87.7227 4.0828C90.2177 4.0828 91.9837 5.76777 92.1457 8.32762C92.1781 8.94328 92.2105 9.39693 92.2591 10.5148L92.3725 12.9289H90.2339L90.2015 11.8272C89.6669 12.6859 88.6786 13.1233 87.3825 13.1233ZM87.6741 10.9847C88.954 10.9847 89.8127 10.1584 89.8127 8.63545C89.8127 7.22591 88.954 6.27002 87.6741 6.27002C86.3779 6.27002 85.4869 7.22591 85.4869 8.63545C85.4869 10.0774 86.3293 10.9847 87.6741 10.9847Z"
          fill={color}
        />
        <path
          d="M77.5186 13.1233C75.1208 13.1233 73.3872 11.5841 73.128 9.23491C73.0794 8.78127 73.0794 8.24662 73.0794 7.87398V1.18272H75.4286L75.3962 4.90909C75.9956 4.40684 76.8543 4.0828 77.8588 4.0828C80.3701 4.0828 82.0874 5.92979 82.0874 8.63545C82.0874 11.3087 80.2405 13.1233 77.5186 13.1233ZM77.5834 10.9361C78.8633 10.9361 79.7544 9.98019 79.7544 8.60305C79.7544 7.20971 78.8795 6.25382 77.5834 6.25382C76.3035 6.25382 75.4124 7.20971 75.4124 8.60305C75.4124 9.98019 76.3197 10.9361 77.5834 10.9361Z"
          fill={color}
        />
        <path
          d="M70.507 12.9289C68.1577 12.9289 66.7158 11.649 66.7158 8.48964V2.18722H69.065V4.34203H71.9489V6.44824H69.065V8.79747C69.065 10.4338 69.7617 10.7579 70.993 10.7579C71.7869 10.7579 71.9327 10.7417 72.0137 10.7417L71.7545 12.9289H70.507Z"
          fill={color}
        />
        <path
          d="M61.0478 13.1233C58.3907 13.1233 56.5113 11.2601 56.5113 8.60305C56.5113 5.94599 58.3907 4.0828 61.0478 4.0828C63.7048 4.0828 65.5842 5.94599 65.5842 8.60305C65.5842 11.2601 63.7048 13.1233 61.0478 13.1233ZM61.0316 10.9361C62.3277 10.9361 63.235 9.98019 63.235 8.60305C63.235 7.22591 62.3277 6.25382 61.0478 6.25382C59.7678 6.25382 58.8606 7.22591 58.8606 8.60305C58.8606 9.98019 59.7516 10.9361 61.0316 10.9361Z"
          fill={color}
        />
        <path
          d="M50.9224 13.1233C48.2653 13.1233 46.3859 11.2601 46.3859 8.60305C46.3859 5.94599 48.2653 4.0828 50.9224 4.0828C53.5795 4.0828 55.4589 5.94599 55.4589 8.60305C55.4589 11.2601 53.5795 13.1233 50.9224 13.1233ZM50.9062 10.9361C52.2023 10.9361 53.1096 9.98019 53.1096 8.60305C53.1096 7.22591 52.2023 6.25382 50.9224 6.25382C49.6425 6.25382 48.7352 7.22591 48.7352 8.60305C48.7352 9.98019 49.6263 10.9361 50.9062 10.9361Z"
          fill={color}
        />
        <path
          d="M42.4014 5.63816C42.4014 2.52745 43.4221 0.955895 46.0305 0L46.8892 2.07381C45.5931 2.55985 44.9288 3.20792 44.783 4.34203H46.1115V6.30242H44.7506V12.9289H42.4014V5.63816Z"
          fill={color}
        />
        <path
          d="M37.1285 13.1233C34.2608 13.1233 32.5272 11.3249 32.5272 8.65166C32.5272 5.99459 34.3742 4.0828 37.0313 4.0828C39.5749 4.0828 41.2437 5.88118 41.2437 8.65166C41.2437 8.84607 41.2275 9.0891 41.2113 9.28352H34.8765C35.0709 10.4824 35.8 11.0333 37.1609 11.0333C38.1168 11.0333 38.8297 10.7255 39.3319 10.0288L41.1789 11.1305C40.2554 12.4914 38.9593 13.1233 37.1285 13.1233ZM34.9737 7.51754H38.8135C38.6839 6.70746 38.0682 6.18901 36.9827 6.18901C35.9458 6.18901 35.2653 6.65886 34.9737 7.51754Z"
          fill={color}
        />
        <path
          d="M27.486 13.1233C24.829 13.1233 23.2088 11.2601 23.2088 8.60305C23.2088 5.89738 25.0072 4.0828 27.6156 4.0828C29.6894 4.0828 31.4716 5.26552 31.5526 7.48514H29.2034C29.1386 6.69126 28.4257 6.25382 27.5994 6.25382C26.3357 6.25382 25.558 7.16111 25.558 8.60305C25.558 10.0288 26.2709 10.9361 27.5832 10.9361C28.3285 10.9361 29.09 10.612 29.2358 9.80197H31.6012C31.4068 11.973 29.7704 13.1233 27.486 13.1233Z"
          fill={color}
        />
        <path
          d="M19.6514 12.9289V4.34203H22.0006V12.9289H19.6514ZM19.6514 3.66156V1.66876H22.0006V3.66156H19.6514Z"
          fill={color}
        />
        <path
          d="M10.2855 5.63816C10.2855 2.52745 11.3062 0.955895 13.9146 0L14.7895 2.13861C13.5582 2.54365 12.8939 3.24032 12.6995 4.34203H14.8219C15.0974 2.07381 16.1667 0.81008 18.3863 0L19.2612 2.13861C18.0299 2.54365 17.3656 3.24032 17.1712 4.34203H18.4673V6.30242H17.1064V12.9289H14.7571V6.30242H12.6347V12.9289H10.2855V5.63816Z"
          fill={color}
        />
        <path
          d="M4.53645 13.1233C1.87939 13.1233 0 11.2601 0 8.60305C0 5.94599 1.87939 4.0828 4.53645 4.0828C7.19351 4.0828 9.0729 5.94599 9.0729 8.60305C9.0729 11.2601 7.19351 13.1233 4.53645 13.1233ZM4.52025 10.9361C5.81638 10.9361 6.72367 9.98019 6.72367 8.60305C6.72367 7.22591 5.81638 6.25382 4.53645 6.25382C3.25652 6.25382 2.34923 7.22591 2.34923 8.60305C2.34923 9.98019 3.24032 10.9361 4.52025 10.9361Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
